import React from "react";
import { Link } from "react-router-dom";
import { Formik, Field, Form } from "formik";
import { useAuth } from "store/auth";
import { minLength6, required, validationWrapper } from "lib/formValidations";
import { isUserName } from "lib/formValidations";
import { TextField, Loading } from "components/form";

export default function Login() {
  const { submitLogin, dispatch } = useAuth();
  return (
    <>
      <div className="login">
        <div className="container sm:px-10">
          <div className="block xl:grid grid-cols-2 gap-4">
            <div className="hidden xl:flex flex-col min-h-screen">
              <a href="" className="-intro-x flex items-center pt-5">
                <img
                  alt="هاشور"
                  className="h-10"
                  src="/images-panel/hashure.svg"
                />
              </a>
              <div className="my-auto">
                <img
                  alt="هاشور"
                  className="-intro-x w-1/2 -mt-16"
                  src="/images-panel/illustration.svg"
                />
                <div className="-intro-x text-white font-medium text-4xl leading-tight mt-10">
                  هاشور
                  <br />
                  نوع دیگر دیدن
                </div>
                <div className="-intro-x mt-5 text-lg text-white text-opacity-70 dark:text-gray-500">
                  پنل مدیریت
                </div>
              </div>
            </div>

            <div className="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
              <div className="my-auto mx-auto xl:ml-20 bg-white dark:bg-dark-1 xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto">
                <h2 className="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-right">
                  ورود به پنل مدیریت
                </h2>
                <Formik
                  initialValues={{ password: "" }}
                  onSubmit={async (values, { setSubmitting }) => {
                    await dispatch(
                      submitLogin({ ...values }, () => {
                        window.location = "/";
                      })
                    );
                    setSubmitting(false);
                  }}
                >
                  {({ isSubmitting }) => (
                    <Form>
                      <div className="intro-x mt-8">
                        <Field
                          placeholder="نام کاربری"
                          name="userName"
                          component={TextField}
                          validate={(value) =>
                            validationWrapper(value, required, isUserName)
                          }
                        />
                        <Field
                          placeholder="کلمه عبور"
                          name="password"
                          type="password"
                          component={TextField}
                          validate={(value) =>
                            validationWrapper(value, required, minLength6)
                          }
                        />
                      </div>
                      <div className="intro-x flex text-gray-700 dark:text-gray-600 text-xs sm:text-sm mt-4">
                        <Link to="/auth/resetpassword">فراموشی کلمه عبور؟</Link>
                      </div>
                      <div className="intro-x mt-5 xl:mt-8 text-center xl:text-left">
                        <button
                          className="btn btn-primary py-3 px-4 w-full xl:w-32 xl:mr-3 align-top"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? <Loading /> : "ورود"}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
